import React from 'react'

export const DrawingLayer = ({children, ...props}: any) => (
	<div style={{position: 'relative', flexGrow: 1, height: '100%'}} {...props}>
		{children}
	</div>
);